<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app clipped style="width: 300px;">
      <v-list three-line>
        <!-- <v-list-item @click="view(l)" v-for="(l, idx) in locations" :key="idx" link>
          <v-list-item-avatar>
            <v-img :src="l.flag" alt="flag"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ l['CNAME'] }}
              <v-badge color="red" inline :content="'+' + l.today.confirmed" :dark="isDarkTheme">
                <span class="font-weight-bold">
                  <ICountUp class="red--text text--darken-2" :endVal="l.confirmed" />
                </span>
              </v-badge>
            </v-list-item-title>
            <v-list-item-subtitle>
              种类:
              <ICountUp :endVal="l.death" />
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              贸易金额:
              <ICountUp :endVal="l.recovered" />
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item> -->

        <!-- 新增 import_ranking 列表 -->
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">贸易种类排名</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          class="techy-list-item"
          v-for="(item, idx) in importRankingList"
          :key="'import-' + idx"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold"
              >{{ idx + 1 }}. {{ item.name }}</v-list-item-title
            >
            <v-list-item-subtitle> 金额: {{ item.amount }}亿美元 </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <!-- 结束 import_ranking 列表 -->
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        全球进出口数据
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <!-- <v-btn text value="left" @click="home">
        <v-icon left>mdi-home-variant-outline</v-icon>
        <span class="hidden-sm-and-down">首页</span>
      </v-btn>
      <v-btn text value="center" href="/COVID-19-Dashboard/3d/" target="_Blank">
        <v-icon left>mdi-earth</v-icon>
        <span class="hidden-sm-and-down">3D展示</span>
      </v-btn>

      <v-btn text value="right" @click="chart">
   
        <v-icon left>mdi-chart-areaspline</v-icon>
        <span class="hidden-sm-and-down">国家对比</span>
      </v-btn>
      <v-btn text value="right" @click="Ranking">
     
        <v-icon left>mdi-chart-bar</v-icon>
        <span class="hidden-sm-and-down">动态排名</span>
      </v-btn> -->
      <!-- <v-btn text value="right" @click="who">
        chart-bell-curve-cumulative
        <v-icon left>mdi-hospital-box</v-icon>
        <span class="hidden-sm-and-down">疾病知识</span>
      </v-btn> -->
      <!-- <v-btn value="right">
          <span class="hidden-sm-and-down">搜索</span>

          <v-icon right>mdi-format-align-right</v-icon>
        </v-btn>

        <v-btn value="justify">
          <span class="hidden-sm-and-down">Justify</span>

          <v-icon right>mdi-format-align-justify</v-icon>
        </v-btn> -->
      <v-tooltip bottom :dark="isDarkTheme">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="$refs.searchDialog.dialog = true">
            <v-icon>mdi-map-search</v-icon>
          </v-btn>
        </template>
        <span>搜索</span>
      </v-tooltip>
      <v-tooltip bottom :dark="isDarkTheme">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="TOGGLE_THEME">
            <v-icon>mdi-theme-light-dark</v-icon>
          </v-btn>
        </template>
        <span>风格切换</span>
      </v-tooltip>
    </v-app-bar>

    <v-content>
      <v-container>
        <v-row>
          <v-col cols="12">
            <TotalCases
              :importAmount="importTotal"
              :exportAmount="exportTotal"
              :deaths="cases.total_death"
              :today_confirmed="'+' + cases.today_confirmed"
              :today_recovered="'+' + cases.today_recovered"
              :today_death="'+' + cases.today_death"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card tile style="height: 70vh;" flat>
              <!-- 中间地图 -->
              <LeafletMap :cases="cases" ref="map" @MARKER_CLICKED="viewDetails" />
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12"> </v-col>
        </v-row>
      </v-container>

      <!-- Details -->
      <v-dialog width="500" v-model="dialog" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
          <v-card-title>
            <span v-show="$vuetify.breakpoint.smAndUp" class="headline">{{
              selected.country
            }}</span>
            <span v-show="$vuetify.breakpoint.xsOnly" class="headline">{{ selected.country }}</span>
            <v-spacer></v-spacer>
            <v-btn v-show="$vuetify.breakpoint.xsOnly" @click="dialog = false" icon>
              <span>关闭</span>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div>
              <!-- <p>国家/地区: {{ selected['CNAME'] }}</p> -->
              <p v-show="selected['Province/State']">省份/洲: {{ selected['Province/State'] }}</p>
              <div style="width:49%;float:left">
                <p>
                  出口金额:
                  <ICountUp
                    class=" text--darken-2"
                    style="color: skyblue;"
                    :endVal="selected.confirmed"
                  />
                </p>
              </div>
              <div style="width:49%;float:right">
                <p>
                  进口金额:
                  <ICountUp
                    class=" text--darken-2"
                    style="color: skyblue;"
                    :endVal="selected.today_confirmed"
                  />
                </p>
              </div>
              <div>
                <img :src="selected['flag']" width="250px" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions v-show="$vuetify.breakpoint.smAndUp">
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-content>

    <v-snackbar v-model="snackbar" bottom right :timeout="0">
      An update is available
      <v-btn dark text @click="reload">Reload</v-btn>
    </v-snackbar>

    <SearchDialog ref="searchDialog" :data="cases.data" @PLACE_SELECTED="viewDetails" />

    <!-- <v-footer app>
      <span>&copy; 2020</span>
    </v-footer>-->
  </v-app>
</template>

<script>
import ICountUp from 'vue-countup-v2';
import { mapState, mapMutations } from 'vuex';
import axios from 'axios';
import LeafletMap from './components/Map.vue';

// import Tweets from './components/Tweets.vue';

import SearchDialog from './components/SearchDialog.vue';

import TotalCases from './components/TotalCases.vue';
import API from './API';

export default {
  name: 'Home',
  components: {
    LeafletMap,

    ICountUp,
    // Tweets,

    SearchDialog,

    TotalCases
  },

  data: () => ({
    publicPath: process.env.BASE_URL,
    drawer: null,
    cases: {
      total_confirmed: 0,
      total_recovered: 0,
      total_death: 0,
      data: []
    },
    chinaData: {},
    selected: {},
    dialog: false,
    loading: false,
    snackbar: false,
    fatalityRate: {
      byAge: [],
      bySex: [],
      byComorbidity: []
    },
    importRankingList: [], // 新增数据属性
    importTotal: 0, // 新增进口总金额
    exportTotal: 0 // 新增出口总金额
  }),

  computed: {
    ...mapState(['isDarkTheme']),
    locations() {
      const data = [];
      this.cases.data.forEach(item => {
        const idx = data.findIndex(i => i['Country/Region'] === item['Country/Region']);
        const { confirmed } = item.dates[item.dates.length - 1];
        const { recovered } = item.dates[item.dates.length - 1];
        const { death } = item.dates[item.dates.length - 1];
        if (idx === -1) {
          const obj = {
            ...item,
            confirmed,
            recovered,
            death
          };
          delete obj['Province/State'];
          delete obj.dates;
          data.push(obj);
        } else {
          data[idx].confirmed += confirmed;
          data[idx].recovered += recovered;
          data[idx].death += death;
        }
      });
      return data.sort((a, b) => b.confirmed - a.confirmed);
    },
    mainlandChinaCases() {
      return this.cases.data.filter(i => i['Country/Region'] === 'Mainland China');
    }
  },

  async created() {
    this.$vuetify.theme.dark = this.isDarkTheme;
    this.loading = true;
    // 获取 Map.vue 所需的数据
    const mapDataRes = await axios.get('https://exhibition.qingyilian.com/api/bigdata/index');
    if (mapDataRes.data && mapDataRes.data.data && typeof mapDataRes.data.data === 'object') {
      const allRankings = [];
      const regions = mapDataRes.data.data; // 实际数据在 res.data.data
      Object.keys(regions).forEach(regionKey => {
        if (regions[regionKey] && regions[regionKey].ranking) {
          allRankings.push(...regions[regionKey].ranking);
        }
      });
      // Map.vue 实际使用的 newData 赋值逻辑，这里 Home.vue 不需要直接处理
      // 但为了获取 import_ranking，我们可以在这里提取
      if (
        mapDataRes.data.data.globals &&
        Array.isArray(mapDataRes.data.data.globals.import_ranking)
      ) {
        this.importRankingList = mapDataRes.data.data.globals.import_ranking;
      }
      // 提取并赋值 import_total 和 export_total
      if (mapDataRes.data.data.globals) {
        this.importTotal = parseFloat(mapDataRes.data.data.globals.import_total) || 0;
        this.exportTotal = parseFloat(mapDataRes.data.data.globals.export_total) || 0;
      }
    }

    this.cases = await API.getCases();
    this.fatalityRate = await API.getFatalityRate();
    const that = this;
    this.chinaData = await API.getChianData();

    const d = JSON.parse(this.chinaData.data);
    const china = d.areaTree[0];
    window.frames.ChinaMap.contentWindow.updateData(china);
    this.loading = false;
  },

  mounted() {
    document.addEventListener('swUpdated', () => {
      this.snackbar = true;
    });
    const that = this;
  },

  watch: {
    isDarkTheme(val) {
      this.$vuetify.theme.dark = val;
    }
  },

  methods: {
    ...mapMutations(['TOGGLE_THEME']),
    view(location) {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = false;
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
      const { Lat, Long } = location;
      // console.log(location);
      this.$refs.map.flyTo(Lat, Long);
    },
    viewDetails(location) {
      // 判断数据来源，兼容两种结构
      if (location.dates) {
        // 来自 cases.data 的旧结构
        this.selected = {
          ...location,
          confirmed: +location.dates[location.dates.length - 1].confirmed,
          death: +location.dates[location.dates.length - 1].death,
          recovered: +location.dates[location.dates.length - 1].recovered,
          today_confirmed: +location.today.confirmed,
          today_recovered: +location.today.recovered,
          today_death: +location.today.death,
          country: location['Country/Region'] // 确保 country 字段存在
        };
      } else {
        // 来自 newData 的新结构 (从 Map.vue 传入)
        this.selected = {
          ...location,
          country: location.country, // 使用 country 字段作为国家名称
          CNAME: location.country, // 假设 CNAME 也是 country
          confirmed: +location.confirmed || 0,
          death: +location.death || 0, // newData 中可能没有 death，默认为 0
          recovered: +location.recovered || 0, // newData 中可能没有 recovered，默认为 0
          today_confirmed: +location.import || 0, // 使用 newData 中的 import 字段作为新增确诊
          today_recovered: 0, // newData 中没有此字段，默认为 0
          today_death: 0, // newData 中没有此字段，默认为 0
          flag: location.flag || '' // newData 中可能没有 flag，默认为空字符串
        };
      }
      this.dialog = true;
    },
    endReached() {
      this.$refs.tweets.loadMore();
    },
    reload() {
      window.location.reload(true);
    },
    chart() {
      this.$router.replace('/Chart');
    },
    home() {
      this.$router.replace('/');
    },
    who() {
      this.$router.replace('/WHO');
    },
    Ranking() {
      this.$router.replace('/Ranking');
    }
  }
};
</script>

<style scoped>
.ps {
  height: 70vh;
}

.techy-list-item {
  background-color: #262626; /* 深灰色背景，与图片侧边栏颜色近似 */
  border-left: 5px solid #ffffff; /* Vue 绿色左边框 */
  border-radius: 4px;
  margin-bottom: 8px;
  transition: all 0.2s ease-in-out;
}

.techy-list-item:hover {
  background-color: #363636; /* 悬停时稍亮的深灰色 */
  transform: translateX(3px); /* 稍微向右移动 */
}

.techy-list-item .v-list-item-title {
  color: #ffffff; /* 白色文字 */
  font-weight: 500;
}

.techy-list-item .v-list-item-subtitle {
  color: #b0bec5; /* 浅灰色文字，与图片中金额文字近似 */
  font-size: 0.9em;
}
</style>
